<ng-container *ngIf="report">
    <app-report-html-to-pdf [report]="report" (allChartsRendered)="sendReport()"></app-report-html-to-pdf>
</ng-container>